import {
  Component,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { ItemGroup, SelectedValues } from '../../../models/label';

@Component({
  selector: 'muni-gameday-all-radio-selector',
  styleUrls: ['./radio-selector.styles.scss'],
  templateUrl: './radio-selector.template.html'
})
export class RadioSelectorComponent implements OnChanges {
  @Input()
  public itemGroups: ItemGroup[];
  @Input()
  public values: SelectedValues;

  public radioForm: FormGroup = new FormGroup({});

  @Output()
  public selected: Observable<SelectedValues> = this.radioForm.valueChanges;

  public ngOnChanges(changes: SimpleChanges): void {
    if ('itemGroups' in changes) {
      const groups = this.itemGroups;

      _(Object.keys(this.radioForm.controls))
        .difference(_.map(groups, 'id') as string[])
        .each((name) => this.radioForm.removeControl(name));

      groups.forEach((group) => {
        const val = this.values ? this.values[group.id] : undefined;
        let control = <FormControl>this.radioForm.get(group.id);
        if (!control) {
          control = new FormControl(val);
          control.registerOnDisabledChange(
            (isDisabled: boolean) => (group.disabled = isDisabled)
          );
          this.radioForm.addControl(group.id, control);
        }
        this.setGroupDisabled(group.id, group.disabled);
      });
    }

    if (this.values && ('itemGroups' in changes || 'values' in changes)) {
      this.radioForm.patchValue(this.values);
    }
  }

  public setGroupDisabled(id: string, disabled: boolean): void {
    const control = this.radioForm.get(id);
    if (!control) {
      throw new Error(`Group ${id} does not exist`);
    }
    if (disabled) {
      control.disable();
    } else {
      control.enable();
    }
  }
}
